<script setup lang="ts">
import { get } from 'lodash-es';

type Props = {
  modelValue?: string
  field: string
  label: string
  v$?: any
  nestedField?: boolean
  required?: boolean
  typeAttr?: string
  disabled?: boolean
};

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'update:modelValue', event: string | undefined): void
  (e: 'change', value: string | undefined, field: string): void
}>();

const hasError = computed<boolean>(() => {
  if (!props.v$)
    return false;
  const item = props.nestedField ? get(props.v$, props.field) : props.v$[props.field];
  return item ? item.$error : false;
});

function getError() {
  if (!props.v$)
    return '';

  const item = props.nestedField ? get(props.v$, props.field) : props.v$[props.field];
  return item ? item.$errors[0].$message : '&nbsp;';
}
function onChange(value: string | undefined) {
  emit('update:modelValue', value);
  emit('change', value, props.field);
};
</script>

<template>
  <div>
    <Label :for="props.field" :required="props.required">{{ props.label }}</Label>

    <slot>
      <InputText
        :id="props.field"
        :model-value="props.modelValue"
        :type="props.typeAttr ?? 'text'"
        class="block w-full"
        :class="{ 'p-invalid': hasError }"
        :disabled="disabled ?? false"
        @update:model-value="onChange"
      />
    </slot>
    <small v-if="hasError" class="p-error">
      {{ getError() }}
    </small>
    <slot name="info" />
  </div>
</template>

<style scoped></style>
